import { render, staticRenderFns } from "./GekkoTablist.vue?vue&type=template&id=3f3cf476&scoped=true&"
import script from "./GekkoTablist.vue?vue&type=script&lang=js&"
export * from "./GekkoTablist.vue?vue&type=script&lang=js&"
import style0 from "./GekkoTablist.vue?vue&type=style&index=0&id=3f3cf476&lang=scss&scoped=true&"
import style1 from "./GekkoTablist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3cf476",
  null
  
)

export default component.exports